import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function SentRequestError() {
  return (
    <Stack alignItems="center" spacing={7}>
      <Text variant="body1">
        Please try again later or contact our support, if the issue persists.
      </Text>
    </Stack>
  );
}
